import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useTranslation } from 'react-i18next';

const Footer = () => {
    const { t } = useTranslation();
    return (
        <div className="content-wrapper" style={{ paddingBottom: '60px' }}>
        {/* Your page content here */}
            <footer
            className="d-flex justify-content-center align-items-center shadow-sm w-100"
            style={{
                position: 'fixed',
                backgroundColor: 'white',
                borderTop: '1px solid  #e8e8e8',
                height: '50px',
                left: 0,
                right: 0,
                bottom: 0
            }}
            >
            <div className='text-dark'>
                {t("Poweredby")}{" "}
                <a
                href="https://cyberforce.sa"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'rgb(0, 43, 92)', textDecoration: 'none' }}
                >
                Cyberforce.sa
                </a>
            </div>
            </footer>
        </div>

    );
};

export default Footer;
